<template>
  <video-background
    id="home"
    class="main-background"
    :src="require('@/assets/video/apresentacao.mp4')"
    :poster="require('@/assets/img/_foto_principal.jpg')"
    overlay="linear-gradient(45deg,#2a4ae430,#fb949e6b)"
  >
    <div class="h-100 w-100 text-white main-container-flex">
      <gradient-bar :barHeightIn="20" />
      <b-container class="main-content-bottom__numbers">
        <b-row
          class="mb-3 animate__animated animate__slideInUp animate__delay-0.5s"
        >
          <b-col
            lg="3"
            md="6"
            sm="12"
            class="main-content-bottom__item text-center pl-3"
          >
            <div>
              <Icon icon="mdi:plus-thick" style="color: #2d8276" />
              <number
                ref="number1"
                :from="0"
                :to="900"
                :duration="2"
                easing="Power1.easeOut"
              />
              {{ $t("mainpage.mil") }}
            </div>
            <div class="main-content-bottom__subitem">{{ $t("mainpage.numbercount.km") }}</div>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            class="main-content-bottom__item text-center"
          >
            <div class="main-content-bottom__item___principal">
              <Icon icon="mdi:plus-thick" style="color: #3c926a" />
              <number
                ref="number1"
                :from="0"
                :to="3"
                :duration="2"
                easing="Power1.easeOut"
              />
              M
            </div>
            <div class="main-content-bottom__subitem">{{ $t("mainpage.numbercount.habitants") }} </div>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            class="main-content-bottom__item text-center"
          >
            <div class="main-content-bottom__item___principal">
              <Icon icon="mdi:plus-thick" style="color: #6dae4d" />
              <number
                ref="number1"
                :from="0"
                :to="206"
                :duration="2"
                easing="Power1.easeOut"
              />
              Bi
            </div>
            <div class="main-content-bottom__subitem">
              {{ $t("mainpage.numbercount.value.title1") }} <br />{{ $t("mainpage.numbercount.value.title2") }} 
            </div>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            class="main-content-bottom__item text-center pr-3"
          >
            <div>
              <Icon icon="mdi:plus-thick" style="color: #b5cb23" />
              <number
                ref="number1"
                :from="0"
                :to="476"
                :duration="2"
                easing="Power1.easeOut"
              />
              {{ $t("mainpage.mil") }}
            </div>
            <div class="main-content-bottom__subitem">{{ $t("mainpage.numbercount.companies") }}</div>
          </b-col>
        </b-row>
      </b-container>

      <div class="main-content-container">
        <b-container class="main-content-container__text-container">
          <div class="main-content-container__text-container___translate">
            <div
              class="main-content-container__title animate__animated animate__fadeInLeft"
            >
            {{ $t("mainpage.maintext1") }}
            </div>
            <div class="animate__animated animate__fadeInRight">
              <em>{{ $t("mainpage.maintext2") }}</em>
            </div>
          </div>
        </b-container>
      </div>
    </div>
  </video-background>
</template>

<script>
import GradientBar from "@/components/GradientBar.vue";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    Icon,
    GradientBar,
  },
};
</script>

<style scoped>
.main-background {
  position: relative;
  min-height: 100vh;
  /* background-image: url(@/assets/img/_foto_principal.png);
  background-repeat: no-repeat;
  background-position: center; */
}

.main-content-container {
  background-color: transparent;
  color: white;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  line-height: 1;
  position: relative;
}

.main-content-container__text-container {
  position: absolute;
  top: 50vh;
}

.main-content-container__text-container___translate {
  transform: translateY(-50%);
}

.main-container-flex {
  display: flex;
  flex-direction: column-reverse;
}

.main-content-bottom__item {
  padding: 0.5rem 0;
  color: white;
  font-weight: bold;
  font-size: 3.5rem;
}

.main-content-bottom__subitem {
  font-size: 1.2rem;
}

.main-content-bottom__item___principal {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 1200px) {
  .main-content-container {
    font-size: 3rem;
  }

  .main-content-bottom__numbers {
    display: none;
  }
}
</style>
